<template>
  <qx-card-form title="车辆信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 车牌号码 -->
      <section slot="plateNumberInfo" slot-scope="prop">
        <ChooseCar
          :isRadio="true"
          :otherSearchData="{queryType:'1'}"
          :disabled="prop.item.disabled"
          v-model="prop.form.plateNumberInfo"
          @change="handleChange"
        />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
// import {
//   getFileUrl,
// } from 'api';
import ChooseCar from 'components/choose/car';
import {annualReviewCarList} from 'api/car';
export default {
  components: {
    ChooseCar,
  },
  data () {
    return {
      disabled: false,
      otherFormData: {
        plateNumber: '',
        vehicleCode: '',
        orgId: '',
        licenceType: '',
        vehicleOwnerShip: '',
        vehicleLength: '',
        maintainMethod: '',
      },
      baseForm: {
        form: [
          {
            label: '车牌号码',
            value: 'plateNumberInfo',
            default: {},
            slot: true,
            disabled: false,
          },
          {
            label: '车辆归属',
            value: 'orgName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '车辆类型',
            value: 'licenceTypeName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '车辆性质',
            value: 'vehicleOwnerShipName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '品牌名称',
            value: 'brandModelName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '车长',
            value: 'vehicleLengthName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
        ],
        rules: {
          plateNumberInfo: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'change' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请选择车牌号码'),
              trigger: 'blur',
            },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    handleChange () {
      const plateNumberInfo = this.$refs.baseForm.getVal('plateNumberInfo');
      this.setFormValFromData(this.otherFormData, plateNumberInfo);
      for (let name in plateNumberInfo) {
        if (name) {
          for (let item of this.baseForm.form) {
            if (item.value === name) {
              this.$refs.baseForm.setVal(name, plateNumberInfo[name] || ' ');
            }
          }
        }
      }
      this.$emit('plateNumberChange', plateNumberInfo);
    },
    // 从车辆预警列表的处理页面进来
    async jumpFromWarn () {
      const plateNumber = this.$route.query.plateNumber;
      if (plateNumber) {
        const certificatesInsuranceType = this.$route.query.certificatesInsuranceType;
        this.$refs.baseForm.setVal('certificatesInsuranceType', certificatesInsuranceType);
        const res = await annualReviewCarList({ plateNumber: decodeURI(plateNumber) });
        if (!res.failed) {
          if (res.items && res.items[0]) {
            const vehicleInfo = res.items[0];
            this.$emit('plateNumberChange', vehicleInfo);
            for (let item of this.baseForm.form) {
              if (item.value) {
                this.$refs.baseForm.setVal(item.value, vehicleInfo[item.value] || '');
              }
            }
            this.$refs.baseForm.setVal('plateNumberInfo', {
              plateNumber: vehicleInfo.plateNumber,
            });

            this.setFormValFromData(this.otherFormData, vehicleInfo);
            this.setBaseFormChange(true);
          } else {
            this.$refs.baseForm.setVal('plateNumberInfo', '');
            this.$emit('plateNumberChange', 1);
            this.setBaseFormChange(false);
            this.$message({
              type: 'error',
              message: '车辆不存在！',
            });
          }
        }
      }
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          vehicle: {
            ...formData,
            ...this.otherFormData,
          },
        };

        formData.vehicleCode = this.otherFormData.vehicleCode;
        if (formData.plateNumberInfo) {
          formData.plateNumber = formData.plateNumberInfo.plateNumber;
        }
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        formData = {
          ...formData.vehicle,
        };
        delete formData.vehicle;
        delete formData.plateNumberInfo;
      }

      return formData;
    },
    setBaseFormChange (flag) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: flag,
        names: ['plateNumberInfo'],
      });
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();

      if (data.vehicle) {

        for (let item of this.baseForm.form) {
          if (item.value) {
            data[item.value] = data.vehicle[item.value] || '';
          }
        }
        data.plateNumberInfo = {
          plateNumber: data.vehicle.plateNumber,
        };
        if (data.plateNumberInfo && data.plateNumberInfo.plateNumber) {
          this.setBaseFormChange(true);
        } else {
          this.setBaseFormChange(false);
        }
        this.setFormValFromData(this.otherFormData, data.vehicle);
      } else {
        this.setBaseFormChange(false);
        if (this.$route.query.id) {
          this.$message({
            type: 'error',
            message: '车辆不存在！',
          });
        }
      }
      this.$refs.baseForm.setVal(data);
      if (this.$route.query.plateNumber) {
        await this.jumpFromWarn();
      }

    },

  },
};
</script>

<style scoped lang="scss">
</style>
